import api from "@/lib/api";

const QUEUE_KEY = "dfa_attendance_queue";

const safeRead = () => {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch (e) { return []; }
};
const safeWrite = (q) => {
  try { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); } catch (e) {}
};

export const isOnline = () => typeof navigator === "undefined" ? true : navigator.onLine !== false;

export const getQueue = () => safeRead();

export const queueAttendance = (rec) => {
  const q = safeRead();
  q.push({ ...rec, _queued_at: new Date().toISOString(), _id: Math.random().toString(36).slice(2) });
  safeWrite(q);
  return q;
};

export const clearQueue = () => safeWrite([]);

export const syncQueue = async () => {
  if (!isOnline()) return { synced: 0, remaining: safeRead().length, skipped: true };
  let q = safeRead();
  if (q.length === 0) return { synced: 0, remaining: 0 };
  const synced = [];
  const failed = [];
  for (const item of q) {
    try {
      const payload = { ...item };
      delete payload._queued_at; delete payload._id;
      await api.post("/attendance/mark", payload);
      synced.push(item._id);
    } catch (e) {
      failed.push(item);
    }
  }
  safeWrite(failed);
  return { synced: synced.length, remaining: failed.length };
};

export const markAttendanceSmart = async (record) => {
  // If online, send directly; if offline (or error), queue it.
  if (!isOnline()) {
    queueAttendance(record);
    return { mode: "queued", queue_size: safeRead().length };
  }
  try {
    const { data } = await api.post("/attendance/mark", record);
    return { mode: "synced", data };
  } catch (e) {
    queueAttendance(record);
    return { mode: "queued", queue_size: safeRead().length, error: e?.message };
  }
};

// Auto-sync on reconnect
if (typeof window !== "undefined") {
  window.addEventListener("online", () => { syncQueue().catch(() => {}); });
}
